module.exports = __webpack_public_path__ + "img/pg2-article3-c1.32d44293.png";